import { Button, Container } from "@material-ui/core";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { saveAccessTokenAction,saveAzureTokenAction,storeUserDetailsAction } from "../../redux/Actions/actions";
import { useMsal } from "@azure/msal-react";

export default function UnauthorizedAccess() {
  const dispatch = useDispatch();
   const { instance } = useMsal();
  const userdetails = useSelector(
    (state) => state.storeUserDetailsReducer.userData
  );
  function logoutUser(auth, dispatch) {
       dispatch(saveAccessTokenAction(""));
       dispatch(saveAzureTokenAction(""));
       dispatch(storeUserDetailsAction(null));
       localStorage.clear();
       sessionStorage.clear();
       instance.logoutRedirect().catch((error) => console.log(error));
  }
  var newurl =
    window.location.protocol +
    "//" +
    window.location.host +
    window.location.pathname;
  window.history.pushState({ path: newurl }, "", `/`);
  return (
    <>
      <Container maxWidth="sm" style={{marginTop:'10%'}}>
        <div className="master-layout-block">
          <h2 className="clr-red">
            WARNING!!! You are not authorized to access this page.
          </h2>
          <h4 className="clr-white">
            Contact Administrator if there is an issue with your request.
          </h4>
          <Link to="/">
            <Button
              onClick={(auth) => logoutUser(auth, dispatch)}
              className="pt-button--tertiary">
              homepage
            </Button>
          </Link>
        </div>
      </Container>
    </>
  );
}
